module.exports = __webpack_public_path__ + "static/media/paraicon1.542c5f23.webp";